<template>
    <Vueform v-model="model" ref="form" :schema="store.state.vue_personalize_fields" :displayErrors="false"></Vueform>
</template>
<script>
import {useStore} from "vuex";
export default {
    emits: ["update"],
    props: ['person'],
    data: () => ({model: {}, store: useStore()}),
    mounted() {
        this.$nextTick(() => this.$refs.form.update(this.person))
    },
    methods: {
        validate() {
            return new Promise(resolve => {
                this.$refs.form.validate().then(() => {
                    this.$emit('update', this.model);
                    resolve(!this.$refs.form.invalid);
                })
            })
        }
    }
}
</script>
